import { ReactComponent as TextUpperCaseIcon } from "../../../../assets/icons/text-uppercase.svg";
import { ReactComponent as TextLowerCaseIcon } from "../../../../assets/icons/text-lowercase.svg";
import { ReactComponent as TextNormalCaseIcon } from "../../../../assets/icons/text-normal.svg";

import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  TldrEditorAction,
  TldrCustomIconAction,
} from "../../../common/statelessView";
import { FABRIC_TEXT_TYPES } from "../../constants";
import { white } from "../../../styled/variable";
import { FaSubscript, FaSuperscript } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const TLDRTextScript = (props) => {
  const { canvasRef, activeElement } = props;
  const { deltaY: textDeltaY, script: textScript } = activeElement.format;

  const activeObj = canvasRef.handler.canvas.getActiveObject();

  const [script, setScript] = useState(textScript);
  const [deltaY, setDeltaY] = useState(textDeltaY);
  const { t } = useTranslation(["studio"]);

  useEffect(() => {
    const { deltaY, script } = activeElement.format;

    setScript(script);
    setDeltaY(deltaY);
  }, [activeElement.format]);

  function onCaseClick(requestedCase) {
    const { canvasRef } = props;
    canvasRef.handler.textHandler.changeTextCase(requestedCase);
  }

  function onScriptClick(scriptType) {
    const { canvasRef, activeElement } = props;

    const style = canvasRef.handler.textHandler.getStyle(activeElement.format);

    let appliedScript =
      style?.deltaY > 0 ? "sub" : style?.deltaY < 0 ? "super" : undefined;

    canvasRef.handler.textHandler.script(
      scriptType,
      !appliedScript ? "apply" : "remove"
    );
  }

  function callback(action, value) {
    switch (action) {
      case "subscript":
        onScriptClick("sub");
        break;
      case "superscript":
        onScriptClick("super");
        break;
      case "titlecase":
      case "uppercase":
      case "lowercase":
        onCaseClick(action);
        break;
      default:
        return;
    }
  }

  return (
    <>
      <TldrCustomIconAction
        action={"uppercase"}
        icon={<TextUpperCaseIcon fill={white}></TextUpperCaseIcon>}
        title={t("fonts.uppercase")}
        callback={callback}
        showHover={true}
      />
      <TldrCustomIconAction
        action={"lowercase"}
        icon={<TextLowerCaseIcon fill={white}></TextLowerCaseIcon>}
        title={t("fonts.lowercase")}
        callback={callback}
        showHover={true}
      />

      <TldrCustomIconAction
        action={"titlecase"}
        icon={<TextNormalCaseIcon fill={white}></TextNormalCaseIcon>}
        title={t("fonts.title_case")}
        callback={callback}
        showHover={true}
      />
      <div className="tldr-vl" />
      <TldrEditorAction
        action={"subscript"}
        icon={FaSubscript}
        title={t("fonts.subscript")}
        callback={callback}
        showHover={true}
        active={deltaY ? deltaY > 0 : script === "sub"}
        disabled={
          FABRIC_TEXT_TYPES.includes(activeObj?.type) &&
          activeObj?.getSelectedText().length === 0
        }
      />
      <TldrEditorAction
        action={"superscript"}
        icon={FaSuperscript}
        title={t("fonts.superscript")}
        callback={callback}
        showHover={true}
        active={deltaY ? deltaY < 0 : script === "super"}
        disabled={
          FABRIC_TEXT_TYPES.includes(activeObj?.type) &&
          activeObj?.getSelectedText().length === 0
        }
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  activeElement: state.editor.activeElement,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(TLDRTextScript);
